import React, { useEffect, useState } from "react";
import Form from "./Form";

const EnquiryPopup = () => {
  const [showPopup, setShowPopup] = useState(false);

  useEffect(() => {
    const submitted = localStorage.getItem("formSubmitted");
    if (!submitted) {
      setShowPopup(true);
    }
  }, []);

  return (
    <>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <Form closePopup={() => setShowPopup(false)} />
          </div>
        </div>
      )}
    </>
  );
};

export default EnquiryPopup;


// components/EnquiryFormPopup.js
// import React, { useState } from 'react';
// import toast from 'react-hot-toast';
// import Form from './Form';

// const EnquiryFormPopup = ({ onSubmit }) => {
//   const [formData, setFormData] = useState({
//     name: '',
//     email: '',
//     message: ''
//   });

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

   
//     if (!formData.name || !formData.email || !formData.message) {
//       toast.error("Please fill all fields");
//       return;
//     }

//     toast.success("Form Submitted!");
//     onSubmit();
//   };

//   return (
//     <div className="popup-overlay">
//       <div className="popup-content">
//         <Form/>
//       </div>
//     </div>
//   );
// };

// export default EnquiryFormPopup;
